import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { JobStatusCell, SubmissionStatusCell } from './StatusCells';

export type SlideRow = {
  slideId: string;
  refDb: string;
  sampleType: string;
  labellingMode: string;
  submissionStatus: string;
  logStream?: string | null;
  skipReason?: string | null;
  submittedAt: string;
  segmentationStatus?: string | null;
  classificationStatus?: string | null;
  segmentationJobId?: string | null;
  classificationJobId?: string | null;
};

// Same color MUI uses for the table's horizontal lines.
const LINE_COLOR = 'rgba(224, 224, 224, 1)';

const SEPARATOR_BORDER = {
  borderLeft: `1px solid ${LINE_COLOR}`,
};

const SEPARATOR_SX = {
  ...SEPARATOR_BORDER,
  '&&': { paddingLeft: 2 },
};

const GROUP_LABEL_SX = {
  padding: '8px 8px 0',
  fontSize: '0.75rem',
  color: 'text.secondary',
  borderBottom: `1px solid ${LINE_COLOR}`,
};

const HEADER_SX = {
  fontSize: '0.8rem',
  lineHeight: '1.0rem',
  fontWeight: 700,
  py: 1.25,
  px: 1,
  whiteSpace: 'nowrap',
};

const TableAutoTriggering = ({ slides }: { slides: SlideRow[] }) => (
  <TableContainer
    component={Paper}
    sx={{ mt: 3, boxShadow: 0, overflowX: 'auto' }}
  >
    <Table sx={{ minWidth: 650 }}>
      <TableHead>
        <TableRow>
          <TableCell colSpan={4} align='center' sx={GROUP_LABEL_SX}>
            Slide details
          </TableCell>
          <TableCell colSpan={2} sx={GROUP_LABEL_SX} />
          <TableCell
            colSpan={2}
            align='center'
            sx={{ ...GROUP_LABEL_SX, ...SEPARATOR_BORDER }}
          >
            AWS job status
          </TableCell>
        </TableRow>
        <TableRow sx={{ height: 32 }}>
          <TableCell sx={HEADER_SX}>Slide ID</TableCell>
          <TableCell sx={HEADER_SX}>Sample type</TableCell>
          <TableCell sx={HEADER_SX}>Reference database</TableCell>
          <TableCell sx={HEADER_SX}>Labelling mode</TableCell>
          <TableCell sx={HEADER_SX}>Submitted at</TableCell>
          <TableCell sx={HEADER_SX}>Submission status</TableCell>
          <TableCell sx={{ ...HEADER_SX, ...SEPARATOR_SX }}>
            Segmentation status
          </TableCell>
          <TableCell sx={HEADER_SX}>Classification status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody sx={{ '& td': { padding: '4px 8px', whiteSpace: 'nowrap' } }}>
        {slides.map((slide, index) => (
          <TableRow hover key={`${slide.slideId}-${index}`} sx={{ height: 32 }}>
            <TableCell>{slide.slideId}</TableCell>
            <TableCell>{slide.sampleType}</TableCell>
            <TableCell>{slide.refDb}</TableCell>
            <TableCell>{slide.labellingMode}</TableCell>
            <TableCell>{slide.submittedAt}</TableCell>
            <TableCell>
              <SubmissionStatusCell
                status={slide.submissionStatus}
                logStream={slide.logStream}
                skipReason={slide.skipReason}
              />
            </TableCell>
            <TableCell sx={SEPARATOR_SX}>
              <JobStatusCell
                status={slide.segmentationStatus}
                jobId={slide.segmentationJobId}
                jobType='segmentation'
              />
            </TableCell>
            <TableCell>
              <JobStatusCell
                status={slide.classificationStatus}
                jobId={slide.classificationJobId}
                jobType='classification'
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TableAutoTriggering;
